import { useCallback, useRef, useState } from "react";

export type TResetState = () => void;

export type TUseStateReset = <T>(
    initialState: T
) => [T, React.Dispatch<React.SetStateAction<T>>, TResetState];

const useStateReset: TUseStateReset = (initialState) => {
    const initialStateRef = useRef(initialState);
    const [state, setState] = useState(initialState);

    const reset = useCallback(() => {
        setState(initialStateRef.current);
    }, []);

    return [state, setState, reset];
};

export default useStateReset;
